// Typelizer digest ba6ebabe0a60876d8369a0fb40ff1b80
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /learners/preferences */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/preferences', {}, options),
    method: 'post',
  }),

  /** GET /learners/students/:student_id/preferences/edit */
  edit: (
    params: { studentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/students/:student_id/preferences/edit', params, options),
    method: 'get',
  }),

  /** GET /learners/students/:student_id/preferences */
  show: (
    params: { studentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/students/:student_id/preferences', params, options),
    method: 'get',
  }),

  /** PATCH /learners/students/:student_id/preferences */
  update: (
    params: { studentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/students/:student_id/preferences', params, options),
    method: 'patch',
  }),
}
